import { Button, ButtonTheme } from 'components/Button';
import { ICONS } from 'components/Icon';
import { ViewWithSeparators } from 'components/ViewWithSeparators';
import { theme } from 'lib/theme';
import * as React from 'react';
import { View } from 'react-native';
import { NavigationHeader } from 'components/NavigationHeader';
import { SidebarShowButton } from 'componentsAware/SidebarShowButton';
import { Txt } from 'components/Txt';
import { NAVIGATE_MODAL } from 'store/actions';
import { ModalScreens } from 'components/Navigation/types';
import { useDispatch } from 'react-redux';
import { EngagePropertyListItem } from 'types/Engage';
import { pluralise } from 'lib/pluralise';

type Props = {
  onBackPress: () => void;
  property: EngagePropertyListItem;
  pageKey: string;
  scheduledVisitsCount: number;
  isLoading: boolean;
};
export const ScheduledVisitsHeader: React.FC<Props> = ({
  onBackPress,
  property,
  pageKey,
  scheduledVisitsCount,
  isLoading,
}) => {
  const dispatch = useDispatch();

  const handleOpenScheduledVisitModal = React.useCallback(() => {
    dispatch(
      NAVIGATE_MODAL({
        screen: ModalScreens.EngageFlatDoorScheduledVisit,
        size: 'large',
        params: {
          propertyId: property.id,
          pageKey,
        },
      }),
    );
  }, [dispatch, property.id, pageKey]);

  return (
    <View>
      <NavigationHeader marginRight={0} marginLeft={0}>
        <SidebarShowButton />
        <ViewWithSeparators
          horizontal
          style={{
            alignItems: 'center',
            flex: 1,
          }}
          separatorMargin={theme.paddingHorizontalHalf}
          separatorColor="transparent"
        >
          <Button
            icon={ICONS.ChevronLeftLight}
            text="Engage"
            buttonTheme={ButtonTheme.header}
            onPress={onBackPress}
            style={{
              paddingLeft: theme.paddingHorizontalHalf,
              paddingRight: theme.paddingHorizontal,
            }}
            chipLike
          />
          <Txt weight="bold" numberOfLines={1} style={{ flex: 1 }}>
            {property.name}{' '}
            <Txt
              numberOfLines={1}
              style={{ color: theme.colors.fieldValueText }}
            >
              {isLoading
                ? 'Loading Scheduled Visits'
                : pluralise(
                    scheduledVisitsCount,
                    '{x} Scheduled Visit',
                    '{x} Scheduled Visits',
                    'No Scheduled Visits',
                  )}
            </Txt>
          </Txt>
          <Button
            icon={ICONS.PlusLight}
            text={'New'}
            buttonTheme={ButtonTheme.primary}
            onPress={handleOpenScheduledVisitModal}
            style={{
              paddingLeft: theme.paddingHorizontalHalf,
            }}
          />
        </ViewWithSeparators>
      </NavigationHeader>
    </View>
  );
};
